import { render } from "./payroll-overtime-modal.vue?vue&type=template&id=5546d0ea"
import script from "./payroll-overtime-modal.vue?vue&type=script&lang=js"
export * from "./payroll-overtime-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__